<script lang="ts">
  import type { ButtonType } from "./types";
  export let type: ButtonType = "primary";
  export let onClick: () => void = () => {};
  export let fillParent: boolean = false;
</script>

<style>
  .fillParent {
    height: 100%;
    width: 100%;
    padding: 0;
  }
  .normalPadding {
    padding: 1rem 2rem;
  }
  button {
    display: inline-block;
    border: none;
    margin: 0;
    text-decoration: none;
    color: #ffffff;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 150ms ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-radius: 0.2em;
  }

  button:focus {
    outline: 1px solid #fff;
    outline-offset: -2px;
  }

  button:active {
    transform: scale(0.95);
  }

  #primary {
    background-color: var(--theme-accent);
    color: white;
  }
  #primary:hover {
    background-color: hsla(
      var(--theme-accent-h),
      var(--theme-accent-s),
      calc(var(--theme-accent-l) - 10%),
      var(--theme-accent-a)
    );
  }
  #secondary {
    background-color: white;
    color: var(--theme-accent);
    border: 1px solid var(--theme-accent);
  }
  #secondary:hover {
    background-color: hsla(
      var(--theme-accent-h),
      var(--theme-accent-s),
      90%,
      var(--theme-accent-a)
    );
  }
  #disabled {
    background-color: #cbcbcb;
    color: white;
    cursor: default;
  }
</style>

<button
  class:fillParent
  class:normalPadding={!fillParent}
  class="button"
  id={type}
  on:click={() => onClick()}><slot /></button>
